import { ProductTypeEditForm } from 'application/product-type/forms';
import { BaseEditViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ProductTypeService } from 'application/product-type/services';
import { ProductTagService } from 'application/product-tag/services';
import { LookupService } from "common/services";
import { action } from 'mobx';

@applicationContext
class ProductTypeEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ProductTypeService(rootStore.application.baasic.apiClient);
        const lookupService = new LookupService(rootStore.application.baasic.apiClient);
        const productTagService = new ProductTagService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'product-type-edit',
            id: id,
            Form: ProductTypeEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await service.get(id, { embed:'DefaultItemTypeTags,ItemCategory' });

                        response.data.defaultItemTypeTags = response.data.defaultItemTypeTags.map((item) => ({
                            id: item.productTag.id,
                            name: item.productTag.name
                        }));

                        return response.data;
                    },
                    update: async (resource) => {
                        if (resource.defaultItemTypeTags) {
                            resource.defaultItemTypeTags = resource.defaultItemTypeTags.map((item) => ({
                                defaultItemTypeId: id,
                                productTagId: item.id
                            }));
                        }

                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        if (resource.defaultItemTypeTags) {
                            resource.defaultItemTypeTags = resource.defaultItemTypeTags.map((item) => ({
                                defaultItemTypeId: id,
                                productTagId: item.id
                            }));
                        }
                        
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ProductTypeEditForm,
        });

        this.categoryStore = new BaasicDropdownStore(
            {
                initFetch: true,
            },
            {
                fetchFunc: async () => {
                    const response = await lookupService.getLookups(
                        "ItemCategory"
                    );
                    return response.itemCategory.filter(
                        (c) =>
                            c.abrv === "enteral" ||
                            c.abrv === "respiratory" ||
                            c.abrv === "urological" ||
                            c.abrv === "ostomy" ||
                            c.abrv === "wound-care"
                    );
                },
                onChange: async (categoryId) => {
                    this.form.set({ categoryId: categoryId });
                },
            }
        );

        this.tagsStore = new BaasicDropdownStore(
            {
                filterable: true,
                multi: true,
            },
            {
                fetchFunc: async (term) => {
                    const response = await productTagService.find({ searchQuery: term, rpp: 20});
                    return response.data.item.map((item) => ({
                        id: item.id,
                        name: item.name
                    }));
                },
            }
        );
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Product Type already exists.' : err.data.message : `Error occurred while trying to update a Product Type.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Product Type already exists.' : err.data.message : `Error occurred while trying to update a Product Type.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('PRODUCT_TYPE.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('PRODUCT_TYPE.EDIT.SUCCESS_UPDATE', name);
    }    
}

export default ProductTypeEditViewStore;
